import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

const BASE_XIAOHEIHE_API = process.env.BASE_XIAOHEIHE_API

// 邀请好友进入房间/频道
export function inviteFriendJoinRoomOrChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v2/invite'
	return axiosPostHandler(url, args, formdata)
}

// 回应好友邀请
export function responseFriendInvite (args, formdata) {
	let url = BASE_API + '/chatroom/v2/invite/resp'
	return axiosPostHandler(url, args, formdata)
}

// 获取邀请码
export function getChannelInviteCode (args) {
	let url = BASE_API + '/chatroom/v2/invite/code'
	return axiosGetHandler(url, args)
}

// 使用邀请码获取房间频道信息
export function getRoomAndChannelInfoByInviteCode (args) {
	let url = BASE_API + '/chatroom/channel/invite_code_info'
	return axiosGetHandler(url, args)
}

// 使用邀请码获取群聊信息
export function getRoomChatGroupInviteInfo (args) {
	let url = BASE_XIAOHEIHE_API + '/chat_group/invite_code/info'
	return axiosGetHandler(url, args)
}

// 接受邀请码邀请
export function enterChannelByInviteCode (args, formdata) {
	let url = BASE_API + '/chatroom/v2/invite/code/use'
	return axiosPostHandler(url, args, formdata)
}


// 获取邀请好友的推荐列表
export function getInviteRecommendFriends (args) {
	let url = BASE_API + '/chatroom/v1/channel/recommend_invite_friends'
	return axiosGetHandler(url, args)
}

// 获取手机端邀请协议
export function getInviteHeyboxProtocol(args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/invite_mobile_protocol'
	return axiosPostHandler(url, args, formdata)
}

// 回复申请加入房间|频道
export function responseApplyRoom(args, formdata) {
	let url = BASE_API + '/chatroom/v2/apply_join/resp'
	return axiosPostHandler(url, args, formdata)
}

// 获取邀请好友的award
export function getInviteInfo(args) {
	let url = BASE_API + '/chatroom/v2/common/invite_new/info'
	return axiosGetHandler(url, args)
}


// 检测是不是合法的邀请码
export function checkLegalInviteCode (args, formdata) {
	let url = BASE_API + '/chatroom/v2/invite/code/check'
	return axiosPostHandler(url, args, formdata)
}
